import React from 'react';
import cs from 'classnames';
import { useConfigContext } from '@m4b-design/config-provider';
function Grid(props, ref) {
  var children = props.children,
    style = props.style,
    className = props.className,
    direction = props.direction;
  var globalPrefixCls = useConfigContext().prefixCls;
  var prefixCls = "".concat(globalPrefixCls, "-card-grid");
  var handledChildren = React.Children.map(children, function (element) {
    // 如果不是有效元素，会报错
    if (/*#__PURE__*/React.isValidElement(element)) {
      return /*#__PURE__*/React.cloneElement(element, {
        direction: direction
      });
    }
    return element;
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-tid": "m4b_card_grid",
    ref: ref,
    style: style,
    className: cs(prefixCls, className)
  }, handledChildren);
}
var CardComponent = /*#__PURE__*/React.forwardRef(Grid);
CardComponent.displayName = 'CardGrid';
export default CardComponent;